module.exports = __webpack_public_path__ + "img/logo-02.5925c102.png";